import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const ResponsiveTableContainer = ({ children }) => (
  <div style={{ overflowX: 'auto', width: '100%' }}>
    {children}
  </div>
);

const ScopeTable = () =>
  <ResponsiveTableContainer>
    <Table sx={{ minWidth: 600 }} aria-label="customized table">
      <TableHead>
        <TableRow>
          <StyledTableCell style={{ fontSize: 16 }}>Applications</StyledTableCell>
          <StyledTableCell style={{ fontSize: 16 }}>Scopes</StyledTableCell>
          <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
          <StyledTableCell style={{ fontSize: 16 }}>Grant Types</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <StyledTableRow key="Accounts">
          <StyledTableCell>Accounts</StyledTableCell>
          <StyledTableCell>accounts</StyledTableCell>
          <StyledTableCell>
            Current accounts are based on all account numbers (sent by tokens), including deposit accounts and common accounts. There are APIs such as account list, account details, account movements, create a demand account, a participation account or close a demand account, a participation account.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Payments">
          <StyledTableCell>Payments</StyledTableCell>
          <StyledTableCell>payments</StyledTableCell>
          <StyledTableCell>
            Used for the payment of various bills of different companies. Used to transfer money from bank to bank. There are types such as transfer to name, transfer to IBAN, transfer to credit card.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Money Transfer">
          <StyledTableCell>Money Transfer</StyledTableCell>
          <StyledTableCell>moneytransfers</StyledTableCell>
          <StyledTableCell>
            This scope provides APIs for performing domestic and international money transfers. It includes standard transfers such as IBAN, account number, credit card, and FAST/EFT transactions, as well as Kolas transfers, SWIFT transactions, and bulk transfers.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Loans/Financing">
          <StyledTableCell>Loans/Financing</StyledTableCell>
          <StyledTableCell>loans</StyledTableCell>
          <StyledTableCell>
            Bank Loan. The extension of money from a bank to another party with the agreement that the money will be repaid. Participation bank loans are made at without interest.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Credit Card">
          <StyledTableCell>Credit Card</StyledTableCell>
          <StyledTableCell>creditcards</StyledTableCell>
          <StyledTableCell>
            Albaraka’s Credit Cards APIs offer a simple, elegant solution for developers who want to integrate fully functional card listing and card transaction processing into their websites or POS apps.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Information Services">
          <StyledTableCell>Information Services</StyledTableCell>
          <StyledTableCell>public</StyledTableCell>
          <StyledTableCell>
            Services that do not involve any banking transactions, aim to provide customers with information. For example: API’s of ATM and Branch list.
          </StyledTableCell>
          <StyledTableCell>client_credentials</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Investment Products">
          <StyledTableCell>Investment Products</StyledTableCell>
          <StyledTableCell>investments</StyledTableCell>
          <StyledTableCell>
            The act of committing money or capital to an endeavor with the expectation of obtaining an additional income or profit. Foreign currency exchange processes and gold buy/sell process are example of investments services.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Analytics">
          <StyledTableCell>Analytics</StyledTableCell>
          <StyledTableCell>analytics</StyledTableCell>
          <StyledTableCell>
            Under the Analytics Scope, the client's account transactions can be listed, and transaction details can be viewed.
          </StyledTableCell>
          <StyledTableCell>client_credentials</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Cancels">
          <StyledTableCell>Cancels</StyledTableCell>
          <StyledTableCell>cancels</StyledTableCell>
          <StyledTableCell>
            Under the cancel scope, cancellable operations can be listed and cancelled.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Takbis">
          <StyledTableCell>Takbis</StyledTableCell>
          <StyledTableCell>takbis</StyledTableCell>
          <StyledTableCell>
            Under this scope, real estate and cadastre transactions can be carried out.
          </StyledTableCell>
          <StyledTableCell>client_credentials</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Debit Card">
          <StyledTableCell>Debit Card</StyledTableCell>
          <StyledTableCell>debitcards</StyledTableCell>
          <StyledTableCell>
            The Debit Card scope provides APIs for the creation, listing, management, and transaction tracking of debit and digital cards, including functionalities such as account binding, authorization updates, and card detail inquiries.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Webhooks">
          <StyledTableCell>Webhooks</StyledTableCell>
          <StyledTableCell>webhooks</StyledTableCell>
          <StyledTableCell>
            The Webhook scope provides functionalities for creating registrations based on transaction types, listing existing registrations, and viewing webhook notifications.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="QR Codes">
          <StyledTableCell>QR Codes</StyledTableCell>
          <StyledTableCell>qrorders</StyledTableCell>
          <StyledTableCell>
            The QR Codes scope provides APIs for parsing POS QR codes and processing QR-based payments.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Mail Orders">
          <StyledTableCell>Mail Orders</StyledTableCell>
          <StyledTableCell>mailorders</StyledTableCell>
          <StyledTableCell>
            The Mail Order scope provides APIs for managing POS and mail order operations, including campaign listing, transaction tracking, and adding or updating mail order details.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Digital Loan">
          <StyledTableCell>Digital Loan</StyledTableCell>
          <StyledTableCell>digitalloan</StyledTableCell>
          <StyledTableCell>
            The Digital Loan scope is designed to offer individual customers a fully digital personal financing experience from end to end. Within this scope, all financing steps—including application, identity verification, credit assessment, approval, contract signing, and disbursement—can be managed through APIs.
          </StyledTableCell>
          <StyledTableCell>client_credentials</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Virtual Card">
          <StyledTableCell>Virtual Card</StyledTableCell>
          <StyledTableCell>virtualcard</StyledTableCell>
          <StyledTableCell>
            This scope includes APIs for creating virtual cards, listing existing cards, updating card limits, and managing shopping authorization transactions.
          </StyledTableCell>
          <StyledTableCell>password, authorization_code</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Accounts">
          <StyledTableCell>Baas Accounts</StyledTableCell>
          <StyledTableCell>baas_accounts</StyledTableCell>
          <StyledTableCell>
            Current accounts are based on all account numbers (sent by tokens), including deposit accounts and common accounts. There are APIs such as account list, account details, account movements, create a demand account, a participation account or close a demand account, a participation account.
          </StyledTableCell>
          <StyledTableCell>authorization_id</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Money Transfers">
          <StyledTableCell>Baas Money Transfers</StyledTableCell>
          <StyledTableCell>baas_moneytransfers</StyledTableCell>
          <StyledTableCell>
            Used to transfer money from bank to bank. There are types such as transfer to name, transfer to IBAN, transfer to credit card.
          </StyledTableCell>
          <StyledTableCell>authorization_id</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Investment Products">
          <StyledTableCell>Baas Investment Products</StyledTableCell>
          <StyledTableCell>baas_investment</StyledTableCell>
          <StyledTableCell>
            The act of committing money or capital to an endeavor with the expectation of obtaining an additional income or profit. Foreign currency exchange processes and gold buy/sell process are example of investments services.
          </StyledTableCell>
          <StyledTableCell>authorization_id</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Onboarding">
          <StyledTableCell>Baas Onboarding</StyledTableCell>
          <StyledTableCell>baas_onboarding</StyledTableCell>
          <StyledTableCell>
            Onboarding-related services.
          </StyledTableCell>
          <StyledTableCell>client_credentials</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Customers">
          <StyledTableCell>Baas Customers</StyledTableCell>
          <StyledTableCell>baas_customers</StyledTableCell>
          <StyledTableCell>
            The BaaS customer scope contains APIs related to operations such as retrieving customer information, updating customer details, and listing their limits.
          </StyledTableCell>
          <StyledTableCell>client_credentials</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Cancels">
          <StyledTableCell>Baas Cancels</StyledTableCell>
          <StyledTableCell>baas_cancels</StyledTableCell>
          <StyledTableCell>
            Under the BaaS cancel scope, cancellable operations can be listed and cancelled.
          </StyledTableCell>
          <StyledTableCell>authorization_id</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Cards">
          <StyledTableCell>Baas Cards</StyledTableCell>
          <StyledTableCell>baas_cards</StyledTableCell>
          <StyledTableCell>
            This scope enables operations such as listing debit cards and linking accounts to debit cards.
          </StyledTableCell>
          <StyledTableCell>authorization_id</StyledTableCell>
        </StyledTableRow>

        <StyledTableRow key="Baas Common">
          <StyledTableCell>Baas Common</StyledTableCell>
          <StyledTableCell>baas_common</StyledTableCell>
          <StyledTableCell>
            These are some public APIs that can be used under the BaaS title.
          </StyledTableCell>
          <StyledTableCell>authorization_id</StyledTableCell>
        </StyledTableRow>
      </TableBody>
    </Table>
  </ResponsiveTableContainer>;
export default ScopeTable;
